import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { AppText } from '@/components/ui/app-text';
import { colors, radius, spacing } from '@/theme/tokens';

type ChipKind = 'success' | 'warning' | 'error' | 'info';

const KIND_STYLE: Record<ChipKind, { bg: string; fg: string }> = {
  success: { bg: colors.successBg, fg: colors.success },
  warning: { bg: colors.warningBg, fg: colors.warning },
  error: { bg: colors.errorBg, fg: colors.error },
  info: { bg: colors.infoBg, fg: colors.info },
};

/** 10% opacity background + 100% opacity text, per DESIGN.md status chips */
export function StatusChip({ kind, label, icon }: { kind: ChipKind; label: string; icon?: keyof typeof Ionicons.glyphMap }) {
  const { bg, fg } = KIND_STYLE[kind];
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        backgroundColor: bg,
        borderRadius: radius.full,
        paddingVertical: spacing.base,
        paddingHorizontal: spacing.sm,
      }}
    >
      {icon ? <Ionicons name={icon} size={14} color={fg} /> : null}
      <AppText variant="labelMd" color={fg}>
        {label}
      </AppText>
    </View>
  );
}
